import loadFlappy from './init/loadFlappy';
import loadAppOptions from '@cdo/apps/code-studio/initApp/loadApp';

loadAppOptions().then(loadFlappy);
